import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class DashboardManagerTeamService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getDashboardInceptedApeDirectorwiseManager() {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardInceptedApeDirectorwiseManagers;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": this.sessionStorageService.getCurrentRepCode()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getDashboardInceptedApeManagerwiseAdvisors(managerRepCode: string) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardInceptedApeManagerwiseAdvisors;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": managerRepCode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getDashboardGrossRevenueDirectorwiseManager() {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardGrossRevenueDirectorwiseManagers;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": this.sessionStorageService.getCurrentRepCode()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async getDashboardGrossRevenueManagerwiseAdvisors(managerRepCode: string) {
    const API_URL: string = environment.baseUrl + environment.apis.dashboardGrossRevenueManagerwiseAdvisors;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "repcode": managerRepCode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

}
